module.exports = __webpack_public_path__ + "static/media/bluegrey.180f97ce.png";